import React, { useState, useEffect, useRef } from 'react';
import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { getFunctions, httpsCallable } from "firebase/functions";

function RequestAccessModal({ onClose }) {
  const [formData, setFormData] = useState({
    nombre: '', email: '', empresa: '', tipoCarnet: '', vigenciaCarnet: ''
  });
  const [emicarFile, setEmicarFile] = useState(null);
  const [lamaFile, setLamaFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState('');
  const modalRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape' && !isSubmitting) onClose(); };
    document.addEventListener('keydown', handleEscape);
    modalRef.current?.focus();
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose, isSubmitting]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFeedback('Enviando solicitud...');

    try {
      let emicarUrl = '';
      let lamaUrl = '';

      if (emicarFile) {
        setFeedback('Subiendo foto EMICAR...');
        const emicarRef = ref(storage, `solicitudes_registro/${uuidv4()}-${emicarFile.name}`);
        const snapshot = await uploadBytes(emicarRef, emicarFile);
        emicarUrl = await getDownloadURL(snapshot.ref);
      }
      if (lamaFile) {
        setFeedback('Subiendo foto LAMA...');
        const lamaRef = ref(storage, `solicitudes_registro/${uuidv4()}-${lamaFile.name}`);
        const snapshot = await uploadBytes(lamaRef, lamaFile);
        lamaUrl = await getDownloadURL(snapshot.ref);
      }

      setFeedback('Procesando solicitud...');
      const functions = getFunctions();
      const solicitarAcceso = httpsCallable(functions, 'solicitarAcceso');
      const result = await solicitarAcceso({ ...formData, emicarUrl, lamaUrl });

      if (result.data.success) {
        setFeedback("¡Solicitud enviada! Un administrador la revisará.");
        setTimeout(onClose, 2500);
      } else {
        throw new Error(result.data.message);
      }
    } catch (error) {
      console.error("Error al enviar solicitud:", error);
      setFeedback("Error al enviar. Intentá de nuevo.");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={() => !isSubmitting && onClose()}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="request-title"
        ref={modalRef}
        tabIndex={-1}
        style={{ maxWidth: '480px' }}
      >
        <div className="modal-header">
          <h2 id="request-title">Solicitud de Registro</h2>
        </div>
        <div className="modal-body">
          <p style={{ fontSize: '14px', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-md)' }}>
            Completá tus datos para solicitar acceso.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="req-nombre" className="form-label">Nombre Completo</label>
              <input id="req-nombre" name="nombre" className="form-input" value={formData.nombre} onChange={handleInputChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="req-email" className="form-label">Correo Electrónico</label>
              <input id="req-email" type="email" name="email" className="form-input" value={formData.email} onChange={handleInputChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="req-empresa" className="form-label">Empresa</label>
              <input id="req-empresa" name="empresa" className="form-input" value={formData.empresa} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="req-carnet" className="form-label">Tipo de Carnet</label>
              <input id="req-carnet" name="tipoCarnet" className="form-input" value={formData.tipoCarnet} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="req-vigencia" className="form-label">Vigencia del Carnet</label>
              <input id="req-vigencia" type="date" name="vigenciaCarnet" className="form-input" value={formData.vigenciaCarnet} onChange={handleInputChange} />
            </div>
            <div className="form-group">
              <label htmlFor="req-emicar" className="form-label">Foto Carnet EMICAR</label>
              <input id="req-emicar" type="file" accept="image/*" className="form-input" onChange={(e) => e.target.files[0] && setEmicarFile(e.target.files[0])} />
            </div>
            <div className="form-group">
              <label htmlFor="req-lama" className="form-label">Foto Carnet LAMA</label>
              <input id="req-lama" type="file" accept="image/*" className="form-input" onChange={(e) => e.target.files[0] && setLamaFile(e.target.files[0])} />
            </div>

            {feedback && (
              <p style={{ textAlign: 'center', fontWeight: 600, fontSize: '14px', margin: 'var(--space-md) 0', color: 'var(--color-primary)' }}>
                {feedback}
              </p>
            )}

            <div className="modal-footer" style={{ padding: 0 }}>
              <button type="button" onClick={onClose} disabled={isSubmitting} className="btn btn-outline">Cancelar</button>
              <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RequestAccessModal;
